import { Button } from '@material-ui/core';
import React from 'react';

import { IWizardStepProps } from '~/src/dash/components/wizard';

interface IWizardButtonProps extends IWizardStepProps {
  nextButtonText?: string;
  backButtonText?: string;
  removeBackButton?: boolean;
  disableBackButton?: boolean;
  removeNextButton?: boolean;
  disableNextButton?: boolean;
}

const WizardButtons = ({
  onNext,
  onBack,
  nextButtonText,
  backButtonText,
  removeBackButton,
  disableBackButton,
  removeNextButton,
  disableNextButton,
}: IWizardButtonProps) => {
  return (
    <div
      style={{
        marginTop: '25px',
      }}
    >
      {removeBackButton ? null : (
        <Button
          onClick={onBack}
          style={{
            minWidth: '80px',
            color: '#6571ea',
            fontWeight: 500,
            marginRight: '15px',
            textTransform: 'none',
          }}
          disabled={disableBackButton}
        >
          {backButtonText || 'Back'}
        </Button>
      )}

      {removeNextButton ? null : (
        <Button
          onClick={onNext}
          style={{
            minWidth: '80px',
            color: 'white',
            fontWeight: 500,
            textTransform: 'none',
            backgroundColor: disableNextButton ? '#efeded' : '#4a52ff',
          }}
          disabled={disableNextButton}
        >
          {nextButtonText || 'Next'}
        </Button>
      )}
    </div>
  );
};

export default WizardButtons;
